import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import LinkIcon from '@fabric-ds/icons/dist/16/link-external.svg';
import { Box } from '@fabric-ds/react';
import {
    trackEventOrderProspect,
    trackClickOnLinksInUsefulLinks,
    eventCollectorProjectUrlClick,
    eventCollectorProspectUrlClick,
    trackGoToHomepage,
} from 'common/lib/helpers/trackingService';

const UsefulLinks = ({ projectUrl, orderUrl, moreInfoLinks, orgId, isLeisure }) => {
    const urlMoreAdsSameOrganization = isLeisure
        ? `/realestate/leisuresale/search.html?orgId=${orgId}`
        : `/realestate/newbuildings/search.html?orgId=${orgId}`;

    const externalLink = (url, title, icon, trackEvent) => {
        return (
            !_.isEmpty(url) && (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer external nofollow"
                    className="flex justify-between gap-8"
                    onClick={trackEvent}
                >
                    {title}{' '}
                    {icon && (
                        <LinkIcon height="16" width="16" className="text-gray-700 m-4" style={{ minWidth: '16px' }} />
                    )}
                </a>
            )
        );
    };

    const internalLink = (url, title) => {
        return !_.isEmpty(url) && <a href={url}>{title}</a>;
    };

    return (
        <Box bordered className="my-16">
            <h3>Nyttige lenker</h3>
            {moreInfoLinks &&
                moreInfoLinks.length > 0 &&
                moreInfoLinks
                    .slice(0, 4)
                    .map((link, index) => (
                        <p key={`more-info-link-${index}`}>
                            {externalLink(link.url, link.urlText, true, () =>
                                trackClickOnLinksInUsefulLinks('Sidebar')
                            )}
                        </p>
                    ))}
            {projectUrl && (
                <p>
                    {externalLink(projectUrl, 'Se prosjektets hjemmeside', true, () => {
                        eventCollectorProjectUrlClick();
                        trackGoToHomepage();
                    })}
                </p>
            )}
            {orderUrl && (
                <p>
                    {externalLink(orderUrl, 'Se komplett salgsoppgave', true, () => {
                        eventCollectorProspectUrlClick();
                        trackEventOrderProspect();
                    })}
                </p>
            )}
            <p>{internalLink(urlMoreAdsSameOrganization, 'Flere annonser fra annonsør')}</p>
        </Box>
    );
};

UsefulLinks.propTypes = {
    projectUrl: PropTypes.string,
    orderUrl: PropTypes.string,
    moreInfoLinks: PropTypes.array,
    orgId: PropTypes.number.isRequired,
    isLeisure: PropTypes.bool,
};

export default UsefulLinks;
